import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { StoreModel } from '@app/data';
import { environment } from '@env/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StoreService {
  private readonly http = inject(HttpClient);

  private readonly storeNameSignal = signal<string | null>(null);
  private readonly storeIdSignal = signal<string | null>(null);

  public readonly storeTitleSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  storeTitle$: Observable<string> = this.storeTitleSubject.asObservable();

  public readonly storeLogoSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  storeLogo$: Observable<string> = this.storeLogoSubject.asObservable();

  constructor() {
    this.initializeAccount();
  }

  private initializeAccount(): void {
    const storeName = this.getStoreNameFromUrl();
    if (storeName) {
      this.storeNameSignal.set(storeName);
      this.fetchStore(storeName);
    }
  }

  private getStoreNameFromUrl(): string | null {
    const hostname = window.location.hostname;
    const segments = hostname.split('.');
    const storeName = segments[0] || null;
    return storeName;
  }

  private fetchStore(storeName: string): void {
    const host = environment.api.host;
    const prefix = environment.api.prefix;
    const path: string = `${host}${prefix}/sync/conta/${storeName}`;
    this.http.get<StoreModel>(path).subscribe({
      next: (response) => {
        this.storeIdSignal.set(response?.idAccount ?? null);
        this.storeTitleSubject.next(response?.loja ?? null);
        this.storeLogoSubject.next(`https://s3.sa-east-1.amazonaws.com/storage.shopclass.com.br/${storeName}/logotipo.jpg`);
      },
      error: (error) => {
        console.error('storeName not found:', error);
      },
    });
  }

  getStoreName(): string | null {
    return this.storeNameSignal();
  }

  getStoreId(): string | null {
    return this.storeIdSignal();
  }

  getStoreTitle(): Observable<string> {
    return this.storeTitle$;
  }

  getStoreLogo(): Observable<string> {
    return this.storeLogo$;
  }
}
